module.exports = __webpack_public_path__ + "img/img23.9952da2f.jpg";